module.exports = __webpack_public_path__ + "static/img/banner.eab66d06.png";